<template>
    <div class="notice-carousel" ref="noticeCarousel">
        <div class="carousel-container" :style="{
            marginTop: -1 * activeIndex * carouselHeight + 'px',
            transition: 'all ' + transitonTime +'s ease-in-out'
        }">
            <div class="flex" v-for="item in noticeList" :key="item.id" :style="{height: carouselHeight + 'px'}">
                <div class="notice-title flex-grow">{{item.title}}</div>
                <div class="notice-time">{{item.createdAt.split(' ')[0]}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            noticeList: [],
            carouselHeight: null,
            interval: 3000,
            activeIndex: 0,
            transitonTime: 0.5
        }
    },
    mounted () {
        this.getList();
        this.carouselHeight = this.$refs.noticeCarousel.offsetHeight;
    },
    methods: {
        runCarousel () {
            setTimeout(() => {
                this.activeIndex++;
                if (this.activeIndex >= this.noticeList.length) {
                    this.transitonTime = 0
                    this.activeIndex = 0;
                } else {
                    this.transitonTime = 0.5
                }
                this.runCarousel();
            }, this.interval);
        },
        getList () {
            this.axios.get(`/wapi/notice/list?pageNum=1&pageSize=10`).then(res => {
                this.noticeList = res.rows;
                this.runCarousel();
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../assets/less/base.less');
.notice-carousel{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    .notice-title{
      font-size: 18px;
      color: #333333;
      margin-right: 50px;
    }
    .notice-time{
      font-size: 18px;
      color: #B5B5B5;
    }
}
</style>


// WEBPACK FOOTER //
// NoticeCarousel.vue?adc8b284